/**
 * extracts the value from a pixel string
 * @param pxString
 */
export const getPxValueFromString = (pxString: string) => {
  const pxIndex = pxString.indexOf('px');
  if (pxIndex < 0) {
    return pxString;
  } else {
    return pxString.substring(0, pxIndex);
  }
};
